import api from './api';

export default function setAuthToken(token?: string | null) {
	if (token) {
		api.defaults.headers['Authorization'] = `Bearer ${token}`;
	} else {
		delete api.defaults.headers['Authorization'];
	}
}
